var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottledWater(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 21,
    viewBox: "0 0 12 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.80078 0.132812C4.13984 0.132812 3.60078 0.671875 3.60078 1.33281V2.13281C3.60078 2.59687 3.93672 2.93281 4.40078 2.93281C4.40078 3.18906 4.25703 3.37344 4.00078 3.42031C2.11953 3.83281 0.800781 5.45781 0.800781 7.37031V8.18281C0.800781 8.70469 1.13516 9.15469 1.60078 9.32031V14.9578C1.13516 15.1234 0.800781 15.5734 0.800781 16.0953V18.1328C0.800781 19.2359 1.69766 20.1328 2.80078 20.1328H9.20078C10.3039 20.1328 11.2008 19.2359 11.2008 18.1328V16.0953C11.2008 15.5734 10.8664 15.1234 10.4008 14.9578V14.9328H2.40078V14.1328H10.4008V10.1328H2.40078V9.33281H10.4008V9.32031C10.8664 9.15469 11.2008 8.70469 11.2008 8.18281V7.37031C11.2008 5.45781 9.88359 3.83594 7.98828 3.42031C7.74609 3.37656 7.60078 3.18906 7.60078 2.93281C8.06484 2.93281 8.40078 2.59687 8.40078 2.13281V1.33281C8.40078 0.671875 7.86172 0.132812 7.20078 0.132812H4.80078Z",
    fill: "#272A34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottledWater);
export default __webpack_public_path__ + "static/media/BottledWater.6ece2139299bcf39e43f6edc5408e090.svg";
export { ForwardRef as ReactComponent };